import React from 'react';
import { StanjeRobeProduct } from '../types';
import { formatM2, m2PerPallet } from '../utils/stanjeRobeCalc';

type Props = {
  product?: StanjeRobeProduct | null;
  className?: string;
};

/** Prikaz m²/kom, kom/paleta i m²/paleta za izabranu robu (kao referenca pri unosu). */
const StanjeRobeProductM2Info: React.FC<Props> = ({ product, className = 'mb-3' }) => {
  if (!product) return null;

  const m2pp = Number(product.m2PerPiece || 0);
  const perPal = Number(product.perPallet || 0);
  const m2pal = m2PerPallet(product);

  if (!m2pp && !perPal) {
    return (
      <div className={`p-3 surface-100 border-round border-1 border-orange-200 text-sm text-orange-800 ${className}`}>
        <i className="pi pi-exclamation-triangle mr-2" />
        Za ovu robu nisu definisani <strong>m²/kom</strong> i <strong>kom/paleta</strong> — preračun u m² neće raditi dok to ne popunite u šifarniku robe.
      </div>
    );
  }

  return (
    <div className={`p-3 surface-100 border-round border-1 border-200 text-sm ${className}`}>
      <div className="font-semibold mb-2 text-700">Parametri robe za preračun</div>
      <div className="grid">
        <div className="col-4">
          <span className="text-600">m²/kom</span>
          <div className="font-medium">{m2pp > 0 ? formatM2(m2pp) : '—'}</div>
        </div>
        <div className="col-4">
          <span className="text-600">kom/paleta</span>
          <div className="font-medium">{perPal > 0 ? perPal : '—'}</div>
        </div>
        <div className="col-4">
          <span className="text-600">m²/paleta</span>
          <div className="font-medium text-primary">{m2pal > 0 ? `${formatM2(m2pal)} m²` : '—'}</div>
        </div>
      </div>
    </div>
  );
};

export default StanjeRobeProductM2Info;
